module.exports = __webpack_public_path__ + "img/02.ef51f5a7.png";